// Wall of Love Filter
/* global Masonry */
document.addEventListener('DOMContentLoaded', function () {

  displayItems();

  const masonryContainers = document.querySelectorAll('.wall-of-love-grid__container');

  // Initialize Masonry for each container
  masonryContainers.forEach(function (container) {
    const itemsToShow = parseInt(container.getAttribute('data-item-initial'), 10);
    const items = container.querySelectorAll('.wall-of-love-grid__item');

    // Hide extra items initially and show the first batch
    items.forEach(function (item, index) {
      if (index < itemsToShow) {
        item.style.display = '';
        item.classList.add('masonry-visible');
      } else {
        item.style.display = 'none';
        item.classList.remove('masonry-visible');
      }
    });

    // Initialize Masonry with vanilla JS
    new Masonry(container, {
      itemSelector: '.masonry-visible',
      percentPosition: true,
      transitionDuration: '0.3s'
    });

    // Check if the "Load More" button should be visible on page load
    const loadMoreButton = container.parentElement.querySelector('.wall-of-love-grid__load-more');
    if (loadMoreButton) {
      if (items.length > itemsToShow) {
        loadMoreButton.style.display = '';
      } else {
        loadMoreButton.style.display = 'none';
      }
    }
  });

  // Filter change event
  const filterInputs = document.querySelectorAll('.wall-of-love-filter input');
  filterInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      const listItem = this.closest('li');

      // Uncheck all filters first
      filterInputs.forEach(function (inp) {
        inp.checked = false;
        inp.closest('li').classList.remove('active');
      });

      // Check the clicked filter and add 'active' class
      this.checked = true;
      listItem.classList.add('active');

      const label = this.closest('label');
      const subpage = label?.dataset?.subpage;
      const subpageTitle = label?.innerText;

      if (subpage) {
        fetch(subpage)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContainer = doc.querySelector('.wall-of-love-grid__container');
            const oldContainer = document.querySelector('.wall-of-love-grid__container');

            if (newContainer && oldContainer) {
              oldContainer.replaceWith(newContainer);
              displayItems();
              window.history.pushState({}, subpageTitle, subpage);
            }
          });
      }
    });
  });

  // Load More functionality
  const loadMoreButtons = document.querySelectorAll('.wall-of-love-grid__load-more');
  loadMoreButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const container = this.previousElementSibling;
      const itemsToShow = parseInt(container.getAttribute('data-item-initial'), 10);
      const items = Array.from(container.querySelectorAll('.wall-of-love-grid__item'));
      const visibleItems = container.querySelectorAll('.masonry-visible');
      const visibleItemsCount = visibleItems.length;

      // Show the next batch of items
      const newItems = items.slice(visibleItemsCount, visibleItemsCount + itemsToShow);

      newItems.forEach(function (item) {
        item.classList.add('masonry-visible');
        item.style.display = '';
      });

      // Get the Masonry instance
      const masonryInstance = Masonry.data(container);

      if (masonryInstance) {
        // Use Masonry's appended method to add new items
        masonryInstance.appended(newItems);
      }

      // Hide Load More button if no more items to show
      if (items.length <= visibleItemsCount + itemsToShow) {
        button.style.display = 'none';
      }
    });
  });

  // Function to display the first set of items and handle the 'Load More' logic
  function displayItems() {
    const containers = document.querySelectorAll('.wall-of-love-grid__container');

    containers.forEach(function (container) {
      const items = Array.from(container.querySelectorAll('.wall-of-love-grid__item'));
      const itemsToShow = parseInt(container.getAttribute('data-item-initial'), 10);

      // Hide all items first
      items.forEach(function (item) {
        item.style.display = 'none';
        item.classList.remove('masonry-visible');
      });

      // Show only the first 'itemsToShow' elements
      items.slice(0, itemsToShow).forEach(function (item) {
        item.style.display = '';
        item.classList.add('masonry-visible');
      });

      // Destroy previous Masonry instance if it exists
      const existingInstance = Masonry.data(container);
      if (existingInstance) {
        existingInstance.destroy();
      }

      // Initialize Masonry
      const masonryInstance = new Masonry(container, {
        itemSelector: '.masonry-visible',
        percentPosition: true,
        transitionDuration: '0.3s'
      });

      // Trigger layout after initialization
      requestAnimationFrame(function() {
        masonryInstance.layout();
      });

      // Show or hide Load More button based on items
      const loadMoreButton = container.parentElement.querySelector('.wall-of-love-grid__load-more');
      if (loadMoreButton) {
        if (items.length > itemsToShow) {
          loadMoreButton.style.display = '';
        } else {
          loadMoreButton.style.display = 'none';
        }
      }
    });
  }

  // Listen for Firework custom events
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  const debouncedLayoutAdjust = debounce(adjustLayoutUponFireworkRender, 100);

  document.addEventListener('fw:storyblock:render', function () {
    debouncedLayoutAdjust();
  });

  document.addEventListener('fw:embed-feed:render', function () {
    debouncedLayoutAdjust();
  });

  // Update grid layout when Firework is injected dynamically
  function adjustLayoutUponFireworkRender() {
    const containers = document.querySelectorAll('.wall-of-love-grid__container');

    containers.forEach(function (container) {
      // Get the Masonry instance
      const masonryInstance = Masonry.data(container);
      const visibleItems = container.querySelectorAll('.masonry-visible');

      // Check if masonry is initialized and container has visible items
      if (masonryInstance && visibleItems.length > 0) {
        // Use requestAnimationFrame to ensure DOM is fully updated
        requestAnimationFrame(function () {
          masonryInstance.layout();
        });
      }
    });
  }
});
